import * as angular from "angular";

export class CanvassResultService {
    private readonly v2Root: string;
    private readonly apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any, __app_type: string) {
        this.$http = $http;
        this.v2Root =
            __app_type == "LEADER" ? "/v2/organisation/result" : "/v2/result";
        this.apiRoot = __env.apiUrl() + "/canvass/result";
    }

    chartData(params: object): Promise<object> {
        return this.$http.post(this.v2Root + "/chart/data", { params: params });
    }

    statsData(params: object): Promise<object> {
        return this.$http.post(this.v2Root + "/stats/data", { params: params });
    }

    tableData(params: object): Promise<object> {
        return this.$http.post(this.v2Root + "/table/data", { params: params });
    }

    performanceTableData(params: object): Promise<object> {
        return this.$http.post(this.v2Root + "/table/data/performance", {
            params: params,
        });
    }

    pivotTableData(params: object): Promise<object> {
        return this.$http.post(this.v2Root + "/pivot-table/data", {
            params: params,
        });
    }

    dataTableExport(params: object): Promise<object> {
        return this.$http.post(this.v2Root + "/data-table/export", {
            params: params,
        });
    }

    expandRow(params: object): Promise<object> {
        return this.$http.post(this.v2Root + "/table/row", { params: params });
    }

    overview(params: object): Promise<object> {
        return this.$http.get(this.apiRoot + "/overview", { params: params });
    }
}

angular
    .module("vcServices")
    .service("CanvassResultService", CanvassResultService);
